import { createSlice } from "@reduxjs/toolkit";
import {
  createVacancySchedule,
  getVacancyScheduleSimulation,
  getVacancyScheduleSimulations,
  deleteVacancyScheduleSimulation,
} from "../actions/nychaVacancySchedule";
import { logoutUser } from "../actions/account";

const initialState = {
  data: null,
  error: null,
  isLoading: false,
  currentSimulation: null,
  isLoadingCurrent: false,
  simulations: [],
  isLoadingSimulations: false,
  deletingIds: [],
};

const nychaVacancyScheduleSlice = createSlice({
  name: "nychaVacancySchedule",
  initialState,
  reducers: {
    clearVacancySchedule(state) {
      state.data = null;
      state.error = null;
      state.currentSimulation = null;
      state.deletingIds = [];
    },
    clearVacancyScheduleSimulations(state) {
      state.simulations = [];
    },
  },
  extraReducers: {
    [createVacancySchedule.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    [createVacancySchedule.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.data = action?.payload?.data ?? action?.payload;
      state.error = null;
    },
    [createVacancySchedule.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action?.payload ?? action?.error ?? true;
    },
    [getVacancyScheduleSimulation.pending]: (state) => {
      state.isLoadingCurrent = true;
      state.error = null;
    },
    [getVacancyScheduleSimulation.fulfilled]: (state, action) => {
      state.isLoadingCurrent = false;
      state.currentSimulation = action?.payload?.data ?? action?.payload;
      state.error = null;
    },
    [getVacancyScheduleSimulation.rejected]: (state, action) => {
      state.isLoadingCurrent = false;
      state.error = action?.payload ?? action?.error ?? true;
    },
    [getVacancyScheduleSimulations.pending]: (state) => {
      state.isLoadingSimulations = true;
      state.error = null;
    },
    [getVacancyScheduleSimulations.fulfilled]: (state, action) => {
      state.isLoadingSimulations = false;
      state.simulations = action?.payload?.data ?? action?.payload ?? [];
      state.error = null;
    },
    [getVacancyScheduleSimulations.rejected]: (state, action) => {
      state.isLoadingSimulations = false;
      state.error = action?.payload ?? action?.error ?? true;
    },
    [deleteVacancyScheduleSimulation.pending]: (state, action) => {
      const simulationId = action.meta?.arg?.simulationId;
      if (simulationId && !state.deletingIds.includes(simulationId)) {
        state.deletingIds.push(simulationId);
      }
    },
    [deleteVacancyScheduleSimulation.fulfilled]: (state, action) => {
      const deletedId = action?.payload?.deletedSimulationId;
      state.deletingIds = state.deletingIds.filter((id) => id !== deletedId);
      if (deletedId) {
        state.simulations = state.simulations.filter(
          (simulation) => simulation?._id !== deletedId && simulation?.simulationId !== deletedId
        );
        if (state.currentSimulation?._id === deletedId) {
          state.currentSimulation = null;
        }
      }
      state.error = null;
    },
    [deleteVacancyScheduleSimulation.rejected]: (state, action) => {
      const simulationId = action.meta?.arg?.simulationId;
      state.deletingIds = state.deletingIds.filter((id) => id !== simulationId);
      state.error = action?.payload ?? action?.error ?? true;
    },
    [logoutUser.fulfilled]: () => initialState,
    [logoutUser.rejected]: () => initialState,
  },
});

export const getVacancyScheduleData = (state) =>
  state.nychaVacancySchedule.data;
export const getVacancyScheduleError = (state) =>
  state.nychaVacancySchedule.error;
export const getVacancyScheduleLoading = (state) =>
  state.nychaVacancySchedule.isLoading;
export const getVacancyScheduleCurrentSimulation = (state) =>
  state.nychaVacancySchedule.currentSimulation;
export const getVacancyScheduleCurrentLoading = (state) =>
  state.nychaVacancySchedule.isLoadingCurrent;
export const getVacancyScheduleSimulationsList = (state) =>
  state.nychaVacancySchedule.simulations;
export const getVacancyScheduleSimulationsLoading = (state) =>
  state.nychaVacancySchedule.isLoadingSimulations;
export const getVacancyScheduleDeletingIds = (state) =>
  state.nychaVacancySchedule.deletingIds;

export const { clearVacancySchedule, clearVacancyScheduleSimulations } =
  nychaVacancyScheduleSlice.actions;

export default nychaVacancyScheduleSlice;
